<template>
  <section id="portfolio" class="mb-5">
    <h1 class="display-2 text-center mt-5 mb-3">Proyectos</h1>

    <div class="container">
    
    <div class="row d-flex justify-content-center">
        
        <router-link to="/gestion-creditos" class="col-12 m-2 col-lg-3 box" style="background-image: url('/img/works/p5.png');">
            <div  class="text-box">
                <p class="text-center">
                    Gestión Créditos - ERP <br>
                    Proyecto
                </p>
            </div>
        </router-link>
        <router-link to="/ahdeco-pagina-web" class="col-12 m-2 col-lg-3 box" style="background-image: url('/img/works/p3.png');">
            <div class="text-box">
                <p class="text-center">
                    AHDECO - PÁGINA WEB <br>
                    Proyecto
                </p>
            </div>
        </router-link>
        <router-link to="/catalogo-productos" class="col-12 m-2 col-lg-3 box"  style="background-image: url('/img/works/p4.png');">
            <div class="text-box">
                <p class="text-center">
                    Catalogo de productos - E-Commerce <br>
                    Proyecto
                </p>
            </div>
        </router-link>
        <router-link to="/sasep-pagina-web" class="col-12 m-2 col-lg-3 box"  style="background-image: url('/img/works/p6.png');">
            <div class="text-box">
                <p class="text-center">
                    SASEP - PÁGINA WEB <br>
                    Proyecto
                </p>
            </div>
        </router-link>
        <!-- <div class="col-12 m-2 col-lg-3 box"  style="background-image: url('/img/works/p1.jpg');">
            <div class="text-box">
                <p class="text-center">
                    Saber Algo - Blog <br>
                    Proyecto
                </p>
            </div>
        </div> -->
        <!-- <div class="col-12 m-2 col-lg-3 box" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style="background-image: url('/img/works/p1.jpg');">
            <div class="text-box">
                <p class="text-center">
                    Elecciones Honduras 2025 - Blog <br>
                    Proyecto
                </p>
            </div>
        </div> -->

        

            
        </div>  
    </div>
    

</section>
</template>

<script>
export default {

}
</script>

<style>
    .box {
        text-decoration: none;
        
    }
</style>